module.exports = __webpack_public_path__ + "static/media/times.d5d9b274.svg";